var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-complete"},[_c('div',{staticClass:"hero is-large"},[_c('div',{staticClass:"hero-body is-loading"})])])
}]

export { render, staticRenderFns }